module.exports = __webpack_public_path__ + "img/lost-profit.f2dee96a.png";